export const RESET_STATE = 'RESET_STATE';
export const SET_ACTIVE = 'SET_ACTIVE';

export const REQUEST_LOADING = 'BUSINESS_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'BUSINESS_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'BUSINESS_REQUEST_FAILED';
export const UPDATE_CURRENCY = 'BUSINESS_UPDATE_CURRENCY';